document.addEventListener("BSS:changeVariantQV", (e) => {
  setTimeout(() => {
    const productForm = document.querySelector(
      "[bss-b2b-quickview-product-form]"
    );
    BSS_B2B.observer.productSubject.notifyObserver(
      "VariantChange",
      "VariantSelectChange",
      { productForm }
    );
  }, 500);
});

document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (e) => {
    const label = e.target.closest("label");
    const variantSelects = label?.closest("variant-selects");

    if (variantSelects?.hasAttribute("variants-price")) {
      setTimeout(() => {
        document.dispatchEvent(new Event("BSS:changeVariantQV"));
      }, 100);
    }
  });
});
